// extracted by mini-css-extract-plugin
module.exports = {"animation":"content_animation__Hcm6n","animation-playing":"content_animation-playing__rK1q9","animation-complete":"content_animation-complete__ywkUy"};